import styled from "styled-components";

const Testimonial = (props) => {
    return(
        <Container>
            <Content>
                <Caption>
                    <span>Clients words</span>
                    <h2>What our clients say</h2>
                    <p>Testimonies are validation for every product that stands out.</p>
                </Caption>
                <BlogCards>
                    <Card>
                        <div className="card__bio">
                            <img src = "/images/team/partner.jpeg" alt = "" />
                            <div>
                                <Name>Alobo Victor</Name>
                                <span>Partner</span>
                            </div>
                        </div>
                        <div className="client__testimony">
                            I developed a great partnership with <b>winnthako</b> and their dedication to me is evident in all aspects of our interaction. I appreciate their attention to detail. 
                        </div>
                    </Card>
                    <Card>
                        <div className="card__bio">
                            <img src = "/images/team/ayo.jfif" alt = "" />
                            <div>
                                <Name>Ayo Moses Adeyemi</Name>
                                <span>CTO</span>
                            </div>
                        </div>
                        <div className="client__testimony">
                           Working with <b>Winnthako</b> as the Chief Technology Officer has been an exciting one for me. I have been amazed at the extreme understanding of the technoligical team at <b>Winnthako</b>.
                        </div>
                    </Card>
                    <Card>
                        <div className="card__bio">
                            <img src = "/images/team/lawyer.jpeg" alt = "" />
                            <div>
                                <Name>Barr. Agbali Peter</Name>
                                <span>Legal Advisory</span>
                            </div>
                        </div>
                        <div className="client__testimony">
                            Being the Legal Advisor to <b>Winnthako</b> has been an exhilirating one, filled with many adventures to bring this vision a reality. I bless God fo rthe opportunit to serve at <b>Winnthako</b>
                        </div>
                    </Card>
                </BlogCards>
            </Content>
        </Container>
    )
} 

const Container = styled.div`
    padding: 50px 20px;
    color: rgb(96, 96, 96);
    font-size: 15px;
`
const Content = styled.div``

const Caption = styled.div`
    text-align: center;

    span{
        color: rgb(231, 60, 62);
    }
`


const BlogCards = styled.div`
    display: flex;
    flex-direction: column;

    @media(min-width: 768px){
        flex-direction: row;
    }

`

const Card = styled.div`
    display: flex;
    flex-direction: column;
    box-shadow: rgba(231, 60, 62, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
    padding: 50px 20px;

    .card__bio{
        display: flex;

        img{
            width: 50px;
            object-fit: contain;
            display: inline-block;
            margin-right: 20px;
            border-radius: 50%;
        }
    }

    .client__testimony{
        margin-top: 20px;
        font-size: 17px;
        line-height: 30.6px;
    }

`

const Name = styled.div`
    color: rgb(231, 60, 62);
    font-weight: 500;
`

export default Testimonial



